var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00194 3.333C8.00194 4.62148 6.95742 5.666 5.66894 5.666C4.38046 5.666 3.33594 4.62148 3.33594 3.333C3.33594 2.04452 4.38046 1 5.66894 1C6.95742 1 8.00194 2.04452 8.00194 3.333Z",
    stroke: "#86FFC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.333 11.733C10.333 13.533 8.244 15 5.666 15C3.088 15 1 13.537 1 11.733C1 9.92904 3.089 8.46704 5.667 8.46704C8.245 8.46704 10.333 9.92904 10.333 11.733Z",
    stroke: "#86FFC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9406 5.51108C12.9406 6.28428 12.3138 6.91108 11.5406 6.91108C10.7674 6.91108 10.1406 6.28428 10.1406 5.51108C10.1406 4.73789 10.7674 4.11108 11.5406 4.11108C11.9119 4.11108 12.268 4.25858 12.5306 4.52113C12.7931 4.78369 12.9406 5.13978 12.9406 5.51108Z",
    stroke: "#86FFC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-36",
    d: "M12.2031 14.067C13.6169 14.1831 14.8628 13.1445 15.0031 11.733C14.8623 10.3218 13.6165 9.28387 12.2031 9.39998",
    stroke: "#86FFC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cc5cf359dbdfecd542f6f1eff4969bb7.svg";
export { ForwardRef as ReactComponent };